import { useState } from "react";
import { supabase } from "./supabase";

export default function Auth({ onLogin }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isSignUp, setIsSignUp] = useState(false);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const handleSubmit = async () => {
    if (!email.trim() || !password.trim()) return;
    setLoading(true); setMessage("");
    try {
      if (isSignUp) {
        const { error } = await supabase.auth.signUp({ email, password });
        if (error) throw error;
        setMessage("Account created! You can now sign in.");
        setIsSignUp(false);
      } else {
        const { data, error } = await supabase.auth.signInWithPassword({ email, password });
        if (error) throw error;
        onLogin(data.user);
      }
    } catch (error) { setMessage(error.message); }
    setLoading(false);
  };

  return (
    <div style={{ minHeight: "100vh", background: "linear-gradient(135deg, #1A2E3B 0%, #0E4D3A 100%)", display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "Georgia, serif", padding: 20 }}>
      <div style={{ width: "100%", maxWidth: 440 }}>

        <div style={{ textAlign: "center", marginBottom: 40 }}>
          <div style={{ width: 56, height: 56, borderRadius: 14, background: "#0E9F7E", display: "inline-flex", alignItems: "center", justifyContent: "center", marginBottom: 16, boxShadow: "0 4px 20px rgba(14,159,126,0.4)" }}>
            <span style={{ color: "#fff", fontSize: 26, fontWeight: 700 }}>C</span>
          </div>
          <h1 style={{ fontSize: 32, fontWeight: 400, color: "#FFFFFF", margin: "0 0 8px", letterSpacing: 0.5 }}>Attune</h1>
          <p style={{ color: "rgba(255,255,255,0.5)", fontSize: 15, margin: 0 }}>AI-powered therapy documentation</p>
        </div>

        <div style={{ background: "#FFFFFF", borderRadius: 16, padding: "40px", boxShadow: "0 20px 60px rgba(0,0,0,0.3)" }}>
          <h2 style={{ fontSize: 22, fontWeight: 400, color: "#1A2E3B", margin: "0 0 6px" }}>
            {isSignUp ? "Create your account" : "Welcome back"}
          </h2>
          <p style={{ color: "#8FA8B4", fontSize: 14, margin: "0 0 28px" }}>
            {isSignUp ? "Start your free trial today" : "Sign in to your practice"}
          </p>

          <label style={{ fontSize: 12, letterSpacing: 2, color: "#0E9F7E", textTransform: "uppercase", display: "block", marginBottom: 8, fontWeight: 600 }}>Email Address</label>
          <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="you@example.com"
            style={{ width: "100%", background: "#F0F4F8", border: "1px solid #D1E3DD", borderRadius: 8, color: "#1A2E3B", fontSize: 15, padding: "13px 16px", fontFamily: "Georgia, serif", outline: "none", boxSizing: "border-box", marginBottom: 20 }} />

          <label style={{ fontSize: 12, letterSpacing: 2, color: "#0E9F7E", textTransform: "uppercase", display: "block", marginBottom: 8, fontWeight: 600 }}>Password</label>
          <input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="••••••••"
            onKeyDown={e => e.key === "Enter" && handleSubmit()}
            style={{ width: "100%", background: "#F0F4F8", border: "1px solid #D1E3DD", borderRadius: 8, color: "#1A2E3B", fontSize: 15, padding: "13px 16px", fontFamily: "Georgia, serif", outline: "none", boxSizing: "border-box", marginBottom: 8 }} />

          {message && (
            <div style={{ fontSize: 14, color: message.includes("created") ? "#0E9F7E" : "#E74C3C", padding: "10px 14px", background: message.includes("created") ? "#E6F7F3" : "#FDEDEC", borderRadius: 6, marginBottom: 16 }}>
              {message}
            </div>
          )}

          <div style={{ marginBottom: 20 }} />

          <button onClick={handleSubmit} disabled={loading}
            style={{ width: "100%", background: "#0E9F7E", color: "#fff", border: "none", borderRadius: 8, padding: "15px", fontSize: 16, fontWeight: 600, fontFamily: "Georgia, serif", cursor: "pointer", boxShadow: "0 4px 14px rgba(14,159,126,0.35)", marginBottom: 20 }}>
            {loading ? "Please wait..." : isSignUp ? "Create Account" : "Sign In"}
          </button>

          <div style={{ textAlign: "center" }}>
            <span style={{ color: "#8FA8B4", fontSize: 14 }}>{isSignUp ? "Already have an account? " : "New to Attune? "}</span>
            <button onClick={() => { setIsSignUp(!isSignUp); setMessage(""); }}
              style={{ background: "none", border: "none", color: "#0E9F7E", fontSize: 14, fontFamily: "Georgia, serif", cursor: "pointer", fontWeight: 600 }}>
              {isSignUp ? "Sign in" : "Create account"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
